import { DatePicker } from "@mui/x-date-pickers";
import cn from "classnames";
import "./date_picker.scss";
import moment from "moment";
import { Controller } from "react-hook-form";
import { useState } from "react";

export const BrandDatePicker = ({
  label,
  minDate = moment().subtract(130, "years"),
  maxDate,
  value,
  className,
  field,
  onChange,
  isDisabled,
  isReadOnly,
  shouldAllowValidDate,
  invalidDateMessage = "Invalid date",
  isClearable = true,
  error,
  formControl,
  size,
  disablePortal = false,
}) => {
  const [invalidDateError, setInvalidDateError] = useState("");

  const onBlur = () => {
    if (minDate && value && value.isBefore(minDate)) {
      onChange(field, minDate);
    } else if (maxDate && value && value.isAfter(maxDate)) {
      onChange(field, maxDate);
    }
  };

  const datePickerProps = {
    label,
    minDate,
    maxDate,
    disabled: isDisabled,
    readOnly: isReadOnly,
    views: ["year", "month", "day"],
    onError: shouldAllowValidDate
      ? (error) => setInvalidDateError(error ? invalidDateMessage : "")
      : undefined,
    slotProps: {
      textField: {
        error: !!error || !!invalidDateError,
        helperText: error || invalidDateError || undefined,
        onBlur: onBlur,
        size: size,
      },
      field: { clearable: isClearable },
      popper: { disablePortal },
    },
  };

  if (formControl) {
    return (
      <Controller
        name={field}
        control={formControl}
        render={({
          field: { value, ...field },
          fieldState: { error },
        }) => {
          return (
            <DatePicker
              {...field}
              {...datePickerProps}
              value={value || null}
              slotProps={{
                ...datePickerProps.slotProps,
                textField: {
                  ...datePickerProps.slotProps.textField,
                  error: !!error || !!invalidDateError,
                  helperText: error?.message || invalidDateError,
                },
              }}
            />
          );
        }}
      />
    );
  }
  return (
    <div className={cn("brand-date-picker", className)}>
      <DatePicker
        {...datePickerProps}
        value={value}
        onChange={(value) => onChange(field, value)}
      />
    </div>
  );
};
